// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"characteristics-item_itemContainer__1C6-Z","itemContainerRow":"characteristics-item_itemContainerRow__1S2y4","icon":"characteristics-item_icon__3EfNL"};